import {toByteArray} from 'base64-js';

import {UploadedAttachmentModel} from '../../../models/api/attachmentModel';
import {Dispatch} from '../../appStore';
import {getFirstAppPanelId} from '../panelsSelectors';
import {popoutEmlAsyncAction} from './emlPanelActions';
import {EmlSource, EmlSourceTypesEnum} from './emlPanelState';

export function maybePopupEmlPanel(attachment: UploadedAttachmentModel, dispatch: Dispatch) {
  if (!['message/rfc822', 'multipart/signed', 'application/pkcs7-mime'].includes(attachment.contentType)) {
    return false;
  }

  const emlFileDataUrlPrefix = 'data:message/rfc822;base64,';
  const source: EmlSource = attachment.url.startsWith(emlFileDataUrlPrefix)
    ? {
        type: EmlSourceTypesEnum.FILE,
        emlFileContents: String.fromCharCode(
          ...toByteArray(attachment.url.slice(emlFileDataUrlPrefix.length)),
        ),
      }
    : {
        type: EmlSourceTypesEnum.ATTACHMENT,
        attachmentUid: attachment.uid,
      };

  // TODO: Find a better way to get a panel ID in here.
  dispatch((dispatchParam, getState) => {
    const appPanelId = getFirstAppPanelId(getState());
    dispatchParam(popoutEmlAsyncAction(appPanelId, source));
  });

  return true;
}
